import { render, staticRenderFns } from "./HistoryResult.vue?vue&type=template&id=033c93f8&scoped=true&"
import script from "./HistoryResult.vue?vue&type=script&lang=js&"
export * from "./HistoryResult.vue?vue&type=script&lang=js&"
import style0 from "./HistoryResult.vue?vue&type=style&index=0&id=033c93f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c93f8",
  null
  
)

export default component.exports